 export default function ErrorPage() {
    return(
        <div>
            404 page
        </div>
    )
 }